import { CheckIcon } from '@chakra-ui/icons'
import { Button, Flex, Text } from '@chakra-ui/react'
import PhoneNumberInput from '@components/phone-number-input'
import React, { useEffect, useState } from 'react'
import Otp from '../register/otp'
import { COUNTDOWN } from '../register'
import { handleAuthError } from '@lib/util/handle-error'
import { sendOtp } from '@lib/util/customer-handle'
import { useAlert } from '@common/hooks'
import { useForm } from 'react-hook-form'
import AuthLayout from '@layouts/auth-layout'
import DescriptionText from '../description-text'
import AuthForm from '../auth-form'
import axios from 'axios'
import { BACKEND_URL_STORE } from '@constants/server.constant'
import { useAccount } from '@lib/context/account-context'
import { LOCAL_PHONE_VERIFY } from '@constants/local-storage'
import { useRouter } from 'next/router'
import RouterUrl from '@constants/router.constant'

const VerifyOtp = () => {
  const [sentOtp, setSentOtp] = useState(false)
  const [sending, setSending] = useState(false)
  const [phoneError, setPhoneError] = useState<string | undefined>(undefined)
  const [otpVerified, setOtpVerified] = useState(false)
  const [countdown, setCountdown] = useState(0)

  const { customer, refetchCustomer, handleLogout } = useAccount()
  const router = useRouter()

  const { register, control, getValues } = useForm<{ phone?: string }>()

  const { successToast } = useAlert()

  useEffect(() => {
    if (
      customer == null ||
      (customer != null &&
        (customer as any).is_verify_otp === true &&
        customer.phone != null)
    ) {
      router.push(RouterUrl.HOME.ROOT)
    }
  }, [customer])

  useEffect(() => {
    if (otpVerified === true && customer) {
      setSending(true)
      axios
        .post(`${BACKEND_URL_STORE}/customers/update/${customer.id}`, {
          is_verify_otp: true,
          phone: getValues('phone') as string
        })
        .then(() => {
          setSending(false)
          localStorage.removeItem(LOCAL_PHONE_VERIFY)
          refetchCustomer()
          router.push(RouterUrl.HOME.ROOT)
        })
        .catch(() => {
          setSending(false)
          setPhoneError('Error: Cannot verify phone number')
        })
    }
  }, [otpVerified])

  const onSendOtp = async () => {
    setPhoneError('')
    setSending(true)

    const phone = getValues('phone')
    try {
      sendOtp({ phone: phone as string })
        .then(() => {
          successToast({
            title: 'Resend Successfully',
            description: `A new OTP has been sent to your whatsapp`
          })
          setSending(false)
          localStorage.setItem(LOCAL_PHONE_VERIFY, phone as string)
          setSentOtp(true)
          setCountdown(COUNTDOWN)
        })
        .catch((e: any) => {
          handleAuthError(e, (mess) => {
            setPhoneError(mess)
          })
          setSending(false)
        })
    } catch (e) {
      handleAuthError(e, (mess) => {
        setPhoneError(mess)
      })
      setSending(false)
    }
  }

  return (
    <AuthLayout
      title="Verify Phone Number"
      description={
        <DescriptionText>
          Please enter your phone number in the box below to receive OTP.
        </DescriptionText>
      }
    >
      <AuthForm
        flexProps={{ gap: 4 }}
        className="mx-auto sm:w-8/12 md:w-5/12 lg:w-5/12"
      >
        <Flex gap={2}>
          <PhoneNumberInput
            control={control as any}
            {...register('phone', {
              required: 'Phone is required',
              pattern: {
                value: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4,})$/,
                message: 'Phone number invalid'
              }
            })}
            disabled={sentOtp}
          />
          <Button
            bg={'bg'}
            borderRadius={0}
            _hover={{
              bg: 'bg'
            }}
            isLoading={sending}
            type="button"
            onClick={onSendOtp}
            isDisabled={sentOtp}
            rightIcon={<>{otpVerified && <CheckIcon />}</>}
            py={'25px'}
          >
            <Text fontSize={'18px'} fontFamily={'DM Sans Regular, sans-serif'}>
              {otpVerified === true ? 'Verified' : 'Send'}
            </Text>
          </Button>
        </Flex>
        {phoneError && (
          <div>
            <span className="w-full text-rose-500 text-medium-regular">
              {phoneError}
            </span>
          </div>
        )}
        {sentOtp && !otpVerified && (
          <Otp
            phone={getValues('phone') as string}
            countdownOtp={countdown}
            onSetOtpVerified={(input: boolean) => {
              setOtpVerified(input)
            }}
          />
        )}
        <Text fontSize={'18px'} textAlign={'center'}>
          <button
            onClick={() => {
              handleLogout()
            }}
            className="underline"
            type="button"
          >
            Logout
          </button>
        </Text>
      </AuthForm>
    </AuthLayout>
  )
}

export default VerifyOtp
